import React, {useEffect, useState} from "react";
import {
  CardContent,
  Grid,
  Card,
  Box,
  Typography,
  TextField,
  Button,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import CounterCard from "../../components/CounterCard";
import Graph from "../../components/Graph";
import {createDashboardCards} from "../../manager/cardManager";
import {
  createGRNChartData,
  createPoChartData,
  createUploadInvoiceChartData,
} from "../../manager/chartManager";
import {
  getBarChartData,
  getDashboardCount,
} from "../../services/dataService";
import {
  standardDate,
} from "../../manager/dateManager";
import TableLoader from "../../components/TableLoader";
import Empty from "../../components/error/Empty";
import moment from "moment";

const clickable = ["Purchase Orders", "Quality Check","Uploaded Invoices"];

function Dashboard() {
  const [graphType, setGraphType] = useState("line");
  const [fromDate, setFromDate] = useState(standardDate(moment().subtract(1,'year')));
  const [toDate, setToDate] = useState(standardDate(moment()));
  const [overviewItems, setOverviewItems] = useState(
    createDashboardCards("loading")
  );
  const [activeCard, setActiveCard] = useState("Purchase Order");
  const [dashboardPoData, setDashboardPoData] = useState([]);
  const [lineChartData, setLineChartData] = useState({
    labels: [],
    datasets: [],
  });
  const [loading, setLoading] = useState(false);
  const sortHandler = (status) => {
    setActiveCard(status);
    if (status === "Purchase Orders") {
      setLineChartData(createPoChartData(dashboardPoData, fromDate, toDate));
    } else if (status === "Forecast Orders") {
      setLineChartData(createPoChartData(dashboardPoData, fromDate, toDate));
    } else if (status === "Quality Check") {
      setLineChartData(createGRNChartData(dashboardPoData, fromDate, toDate));
    } else if (status === "Uploaded Invoices") {
      setLineChartData(
        createUploadInvoiceChartData(dashboardPoData, fromDate, toDate)
      );
    }
  };

  const getDashBoardData = async () => {
    setLoading(true);
    try {
      setOverviewItems(createDashboardCards("loading"));
      const countResponse = await getDashboardCount({
        FromDate: fromDate,
        ToDate: toDate,
        PageNumber: 1,
        PageSize: 20,
      });
      setOverviewItems(
        createDashboardCards([
          countResponse.data[0].POCount,
          countResponse.data[0].ForecastCount,
          countResponse.data[0].GRNCount,
          countResponse.data[0].InvoiceCount,
        ])
      );
    } catch (error) {
      setOverviewItems(createDashboardCards("error"));
    }
    try {
      const response = await getBarChartData({
        FromDate: fromDate,
        ToDate: toDate,
        PageNumber: 1,
        PageSize: 20,
      });
      setDashboardPoData(response.data);
      setActiveCard("Purchase Orders");
      setLineChartData(createPoChartData(response.data, fromDate, toDate));
    } catch (error) {
      setDashboardPoData([]);
      setLineChartData({
        labels: [],
        datasets: [],
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    getDashBoardData();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Grid container spacing={2} marginTop={0}>
        <Grid container spacing={2}>
          {overviewItems.map((item, index) => (
            <Grid key={index} item xs={12} sm={6} md={6} lg={3}>
              <CounterCard
                description={item.name}
                title={item.value}
                icon={item.icon}
                color={item.dark}
                bgColor={item.light}
                onClickHandler={() => {
                  if (clickable.includes(item.name)) {
                    sortHandler(item.name);
                  }
                }}
                isActive={activeCard === item.name}
              />
            </Grid>
          ))}
          <Grid item lg={12} xs={12} md={12}>
            <Card sx={{pl: 0}}>
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    backgroundColor: "white",
                    mb: 1,
                    borderRadius: 1,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Typography omponent="h4" marginRight={2} variant="h4">
                      {activeCard}
                    </Typography>
                    <FormControl>
                      <RadioGroup
                        row
                        value={graphType}
                        onChange={(e) => setGraphType(e.target.value)}
                      >
                        <FormControlLabel
                          value="line"
                          control={<Radio />}
                          label="Line graph"
                        />
                        <FormControlLabel
                          value="bar"
                          control={<Radio />}
                          label="Bar graph"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <TextField
                      sx={{mr: 3}}
                      type="date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      variant="standard"
                    />
                    To
                    <TextField
                      sx={{mr: 3, ml: 3}}
                      type="date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      variant="standard"
                    />
                    <Button
                      size="small"
                      variant="contained"
                      onClick={getDashBoardData}
                    >
                      submit
                    </Button>
                  </Box>
                </Box>
                <Box
                  sx={{
                    height: 400,
                  }}
                >
                  {loading && <TableLoader />}
                  {!loading && lineChartData.datasets.length === 0 && (
                    <Empty title={"No records found"} />
                  )}
                  {!loading && (
                    <Graph chartData={lineChartData} type={graphType} />
                  )}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default Dashboard;
